import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import { productKeys } from './keys';

import type { TypeGetSkusProductCodeResponse, TypeSkuProductCodeData } from '~/types/product.types';

/**
 * [상품관리] 출하코드조회 (상품코드 기준) API
 * @param skuCode 출하코드(본품 마스터코드)
 */
export const fetchSkusProductCode = async (skuCode: string): Promise<TypeSkuProductCodeData> => {
  const { data } = await axiosInstance.get<TypeGetSkusProductCodeResponse>(
    `${API_ENDPOINT.PRODUCT.GET_SKUS_PRODUCT_CODE}/${skuCode}`
  );
  return data.data;
};

type UseGetSkusProductCodeQueryOptions = {
  skuCode: string;
  enabled?: boolean;
  silent?: boolean;
};

/**
 * [상품관리] 출하코드조회 (상품코드 기준) Query Hook
 * @description 상품 등록/상세(수정)의 출하코드 검색 모달에서 본품 조회에 사용
 */
export const useGetSkusProductCodeQuery = ({
  skuCode,
  enabled = true,
  silent = false,
}: UseGetSkusProductCodeQueryOptions) => {
  return useQuery({
    queryKey: productKeys.skuByProductCode(skuCode),
    queryFn: () => fetchSkusProductCode(skuCode),
    enabled: enabled && !!skuCode,
    staleTime: 0,
    gcTime: 0,
    meta: silent ? { showGlobalErrorToast: false } : undefined,
  });
};
